import { CommonRouteAliases, CommonSearchTabAliases } from "@/shared/environment/common-route-aliases.ts";

export function getPathToProductSelection(tab: CommonSearchTabAliases) {
    return `${CommonRouteAliases.productSelection}?tab=${tab}`;
}
